<template>
  <v-container fluid>
    <div class="d-flex align-center ga-3">
      <v-btn 
        icon 
        large 
        color="primary" 
        @click="fetchAll"
        class="mr-3"
      >
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-tabs
        v-model="currentTabIndex"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
          :tab-value="tab.key"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </div>
    <template v-if="currenTabKey == 'main'">
      <v-row justify="center" dense>
<!--
        <v-text-field
          v-if="notificationSetting"
          outlined
          hide-details
          dense
          class="mr-5"
          label="アプリ更新時通知先"
          style="max-width: 240px;"
          v-model="notificationSetting.value"
          @input="updateNotificationSetting"
        />
-->
        <Dialog
          width="600px"
          @apply="createNewApplication"
          outlined
          :disabled="!isNewApplicationValid"
          :openable="!isUploading"
          @open="initNewApplicationData"
        >
          <template>
            <v-icon class="mr-2">mdi-application</v-icon>
            CWALK本体バージョン追加
          </template>
          <template #title>
            CWALK本体バージョン追加
          </template>
          <template #contents>
            <v-container dense>
              <v-form 
                ref="newApplicationForm" 
                @submit.prevent
                autocomplete="off" 
                lazy-validation
              >
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field
                      dense 
                      outlined
                      class="mt-5" 
                      autocomplete="new-app-name"
                      v-model="newApplicationData.name" 
                      label="名前"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field 
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newApplicationData.versionCode" 
                      label="バージョンコード"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-file-input
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newApplicationData.appFile" 
                      label="zipファイル"
                      accept=".zip"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <MarkdownEditor
                      label="説明"
                      v-model="newApplicationData.description"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </template>
        </Dialog>
      </v-row>

      <ApplicationsTable
        class="mt-5"
        height="calc(100vh - 264px)"
        :items="apps"
        :filter-params="filterParams"
      >
      </ApplicationsTable>
    </template>

    <template v-if="currenTabKey == 'alignment'">
      <v-row justify="center" dense>
        <Dialog
          width="600px"
          @apply="createNewAlignmentApplication"
          outlined
          :disabled="!isNewAlignmentApplicationValid"
          :openable="!isUploading"
          @open="initNewAlignmentApplicationData"
        >
          <template>
            <v-icon class="mr-2">mdi-human</v-icon>
            姿勢分析バージョン追加
          </template>
          <template #title>
            姿勢分析バージョン追加
          </template>
          <template #contents>
            <v-container dense>
              <v-form 
                ref="newAlignmentApplicationForm" 
                @submit.prevent
                autocomplete="off" 
                lazy-validation
              >
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field
                      dense 
                      outlined
                      class="mt-5" 
                      autocomplete="new-app-name"
                      v-model="newAlignmentApplicationData.name" 
                      label="名前"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field 
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newAlignmentApplicationData.versionCode" 
                      label="バージョンコード"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-file-input
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newAlignmentApplicationData.appFile" 
                      label="exeファイル"
                      accept=".exe"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <MarkdownEditor
                      label="説明"
                      v-model="newAlignmentApplicationData.description"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </template>
        </Dialog>
      </v-row>

      <ApplicationsTable
        class="mt-5"
        height="calc(100vh - 264px)"
        :items="alignmentApps"
        :filter-params="filterParams"
        application-type="alignment_app"
      >
      </ApplicationsTable>
    </template>

    <template v-if="currenTabKey == 'help'">
      <v-row justify="center" dense>
        <Dialog
          width="800px"
          @apply="createNewHelpVersion"
          outlined
          :disabled="!isNewHelpVersionValid"
          :openable="!isUploading"
          @open="initNewHelpVersionData"
        >
          <template>
            <v-icon class="mr-2">mdi-help-box</v-icon>
            ヘルプバージョン追加
          </template>
          <template #title>
            ヘルプバージョン追加
          </template>
          <template #contents>
            <v-container 
              dense
              class="d-flex w-100"
            >
              <v-form 
                ref="newHelpVersionForm" 
                @submit.prevent
                autocomplete="off" 
                lazy-validation
                class="flex-grow-1"
              >
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field
                      dense 
                      outlined
                      class="mt-5" 
                      autocomplete="new-app-name"
                      v-model="newHelpVersionData.name" 
                      label="名前"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field 
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newHelpVersionData.versionCode" 
                      label="バージョンコード"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-file-input
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newHelpVersionData.appFile" 
                      label="zipファイル"
                      accept=".zip"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <MarkdownEditor
                      label="説明"
                      v-model="newHelpVersionData.description"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-form>
              <div
                class="d-flex flex-column ga-2 pl-3"
                style="
                  width: 400px;
                "
              >
                <v-chip
                  label
                  color="primary"
                >
                  対応表
                </v-chip>
                <simplebar
                  style="
                    max-height: calc(100vh - 320px);
                  "
                >
                  <v-list dense>
                    <v-list-item
                      v-for="page in pages"
                      :key="`page-${page.id}`"
                      dense
                      style="min-height: 24px;"
                      class="page-item"
                    >
                      <v-chip
                        x-small
                        label
                      >
                        {{ page.name }}
                      </v-chip>
                      <span class="ml-auto text-caption">
                        {{ page.pageCode }}.pdf
                      </span>
                    </v-list-item>
                  </v-list>
                </simplebar>
              </div>
            </v-container>
          </template>
        </Dialog>
      </v-row>

      <ApplicationsTable
        class="mt-5"
        height="calc(100vh - 264px)"
        :items="helps"
        :filter-params="filterParams"
        application-type="help_version"
      >
      </ApplicationsTable>
    </template>

    <template v-if="currenTabKey == 'plugin'">
      <v-row justify="center" dense>
        <Dialog
          width="600px"
          @apply="createNewPlugin"
          outlined
          :disabled="!isNewPluginValid"
          :openable="!isUploading"
          @open="initNewPluginData"
        >
          <template>
            <v-icon class="mr-2">mdi-toy-brick-plus</v-icon>
            プラグインバージョン追加
          </template>
          <template #title>
            プラグインバージョン追加
          </template>
          <template #contents>
            <v-container dense>
              <v-form 
                ref="newPluginForm" 
                @submit.prevent
                autocomplete="off" 
                lazy-validation
              >
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field
                      dense 
                      outlined
                      class="mt-5" 
                      autocomplete="new-app-name"
                      v-model="newPluginData.name" 
                      label="名前"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-text-field 
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newPluginData.versionCode" 
                      label="バージョンコード"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <v-file-input
                      dense 
                      outlined
                      autocomplete="new-app-version-code"
                      v-model="newPluginData.appFile" 
                      label="zipファイル"
                      accept=".zip"
                      :rules="[required]"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col dense>
                    <MarkdownEditor
                      label="説明"
                      v-model="newPluginData.description"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </template>
        </Dialog>
      </v-row>

      <ApplicationsTable
        class="mt-5"
        height="calc(100vh - 264px)"
        :items="plugins"
        :filter-params="filterParams"
        application-type="application_plugin"
      >
      </ApplicationsTable>
    </template>

    <Dialog
      ref="errorDialog"
      :applicable="false"
      :width="errorContent.width ? errorContent.width : '480px'"
    >
      <template #title>
        {{ errorContent.title }}
      </template>
      <template #cancel>
        閉じる
      </template>
      <template #contents>
        <div
          v-html="errorContent.contents"
          class="text-h6 mt-3"
        >
        </div>
      </template>
    </Dialog>

    <v-snackbar 
      v-model="isUploading"
      :timeout="-1"
    >
      <div class="d-flex align-center">
        Uploading...
        <v-progress-linear
          indeterminate
          class="ml-5"
          color="white"
          height="16px"
          striped
        ></v-progress-linear>
      </div>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ApplicationsTable from "@components/parts/tables/ApplicationsTable.vue";
import Dialog from "@components/parts/dialogs/Dialog.vue";
import MarkdownEditor from "@components/inputs/MarkdownEditor.vue";

export default {
  components: {
    ApplicationsTable,
    Dialog,
    MarkdownEditor,
  },
  data: function(){
    return {
      errorContent: {},
      required: value => !!value || "※必須",
      newApplicationData: {},
      newAlignmentApplicationData: {},
      newPluginData: {},
      newHelpVersionData: {},
      isNewApplicationValid: false,
      isNewAlignmentApplicationValid: false,
      isNewPluginValid: false,
      isNewHelpVersionValid: false,
      target: {},
      apps: [],
      alignmentApps: [],
      pages: [],
      plugins: [],
      helps: [],
      isUploading: false,
      filterParams: {
        'isDeleted': false,
      },
      notificationSetting: null,
      tabs: [
        {
          key: 'main',
          name: '本体',
        },
        {
          key: 'alignment',
          name: '姿勢分析',
        },
        {
          key: 'plugin',
          name: 'プラグイン',
        },
        {
          key: 'help',
          name: 'ヘルプ',
        }
      ],
      currentTabIndex: 0,
    }
  },
  computed: {
    ...mapState([
      'user',
      'loadingCount',
    ]),
    isLoading: function(){
      return this.loadingCount > 0;
    },
    currentTab: function(){
      return this.tabs[this.currentTabIndex];
    },
    currenTabKey: function(){
      return this.currentTab?.key;
    },
  },
  watch: {
    newApplicationData: {
      handler: function(){
        this.$nextTick(() => {
          this.isNewApplicationValid = this.$refs.newApplicationForm?.validate();
        });
      },
      deep: true,
    },
    newAlignmentApplicationData: {
      handler: function(){
        this.$nextTick(() => {
          this.isNewAlignmentApplicationValid = this.$refs.newAlignmentApplicationForm?.validate();
        });
      },
      deep: true,
    },
    newPluginData: {
      handler: function(){
        this.$nextTick(() => {
          this.isNewPluginValid = this.$refs.newPluginForm?.validate();
        });
      },
      deep: true,
    },
    newHelpVersionData: {
      handler: function(){
        this.$nextTick(() => {
          this.isNewHelpVersionValid = this.$refs.newHelpVersionForm?.validate();
        });
      },
      deep: true,
    },
    target: {
      handler: function(){
      },
      deep: true,
    },
  },
  destroyed: function(){
  },
  mounted: function(){
    if(!this.user?.role?.isAdmin){
      this.$router.push('/');
      return;
    }

    this.fetchAll();
  },
  methods: {
    ...mapActions([
      'incrementLoadingCount',
      'decrementLoadingCount',
    ]),
    fetchAll: function(){
      this.fetchApplications();
      this.fetchAlignmentApplications();
      this.fetchPlugins();
      this.fetchApplicationPages();
      this.fetchHelpVersions();
//      this.fetchNotificationSetting();
    },
    fetchHelpVersions: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/help_versions`).then(response => {
        this.helps = response.data.helps;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    fetchApplicationPages: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/application_pages`).then(response => {
        this.pages = response.data.pages;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    fetchApplications: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/apps`).then(response => {
        this.apps = response.data.apps;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    fetchAlignmentApplications: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/alignment_apps`).then(response => {
        this.alignmentApps = response.data.apps;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    fetchPlugins: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/application_plugins`).then(response => {
        this.plugins = response.data.plugins;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    /*
    fetchNotificationSetting: function(){
      this.incrementLoadingCount();
      this.axios.get(`/api/setting/app_update_notification`).then(response => {
        this.notificationSetting = response.data.setting;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.decrementLoadingCount();
      });
    },
    updateNotificationSetting: function(){
      this.axios.put(`/api/setting/app_update_notification`, this.notificationSetting).then(response => {
        this.notificationSetting = response.data.setting;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
      });
    },
    */
    createNewAlignmentApplication: function(){
      const params = new FormData();
      params.append('file', this.newAlignmentApplicationData.appFile);
      params.append('app_data_form', 
        JSON.stringify({
          name: this.newAlignmentApplicationData.name,
          versionCode: this.newAlignmentApplicationData.versionCode,
          description: this.newAlignmentApplicationData.description,
        })
      );

      this.isUploading = true;
      this.incrementLoadingCount();
      this.axios.post(
        `/api/alignment_app`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      ).then(() => {
        this.fetchAll();
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isUploading = false;
        this.decrementLoadingCount();
        this.newAlignmentApplicationData = {};
      });
    },
    initNewApplicationData: function(){
      this.newApplicationData = {};
    },
    initNewAlignmentApplicationData: function(){
      this.newAlignmentApplicationData = {};
    },
    initNewPluginData: function(){
      this.newPluginData = {};
    },
    initNewHelpVersionData: function(){
      this.newHelpVersionData = {};
    },
    createNewApplication: function(){
      const params = new FormData();
      params.append('file', this.newApplicationData.appFile);
      params.append('app_data_form', 
        JSON.stringify({
          name: this.newApplicationData.name,
          versionCode: this.newApplicationData.versionCode,
          description: this.newApplicationData.description,
        })
      );

      this.isUploading = true;
      this.incrementLoadingCount();
      this.axios.post(
        `/api/app`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      ).then(response => {
        if(response?.data?.result == 'unsupported'){
          this.errorContent = {
            title: 'エラー',
            contents: 'zipファイルの内容が不適です。<br/>zipファイル内直下はcwalk.exeと_internalフォルダを格納してください。',
            width: '480px',
          }
          this.$refs.errorDialog.open();
        }
        //this.apps.push(response.data.app);
        this.fetchAll();
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isUploading = false;
        this.decrementLoadingCount();
        this.newApplicationData = {};
      });
    },
    createNewPlugin: function(){
      const params = new FormData();
      params.append('file', this.newPluginData.appFile);
      params.append('app_data_form', 
        JSON.stringify({
          name: this.newPluginData.name,
          versionCode: this.newPluginData.versionCode,
          description: this.newPluginData.description,
        })
      );

      this.isUploading = true;
      this.incrementLoadingCount();
      this.axios.post(
        `/api/application_plugin`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      ).then(response => {
        if(response?.data?.result == 'unsupported'){
          this.errorContent = {
            title: 'エラー',
            contents: 'zipファイルの内容が不適です。<br/>zipファイル内直下はpluginフォルダのみを格納してください。',
            width: '480px',
          }
          this.$refs.errorDialog.open();
        }
        this.fetchAll();
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isUploading = false;
        this.decrementLoadingCount();
        this.newPluginData = {};
      });
    },
    createNewHelpVersion: function(){
      const params = new FormData();
      params.append('file', this.newHelpVersionData.appFile);
      params.append('app_data_form', 
        JSON.stringify({
          name: this.newHelpVersionData.name,
          versionCode: this.newHelpVersionData.versionCode,
          description: this.newHelpVersionData.description,
        })
      );

      this.isUploading = true;
      this.incrementLoadingCount();
      this.axios.post(
        `/api/help_version`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      ).then(response => {
        if(response?.data?.result == 'unsupported'){
          this.errorContent = {
            title: 'エラー',
            contents: 'zipファイルの内容が不適です。<br/>zipファイル内直下はPDFファイル（.pdf）のみを格納してください。',
            width: '480px',
          }
          this.$refs.errorDialog.open();
        }

        this.fetchAll();
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isUploading = false;
        this.decrementLoadingCount();
        this.newHelpVersionData = {};
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.page-item{
  &:hover{
    background: #EEE;
  }
}
</style>